import React, { Component } from 'react';
import StatelessSwitcher from '../../components/common/StatelessSwitcher'
import tracker from '../../services/tracker';

export default class Switcher extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isChecked: ('defaultChecked' in this.props) ? this.props.defaultChecked : true
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { onClick, events, eventData } = this.props;
    this.setState({ isChecked: !this.state.isChecked }, () => {
      tracker.sendEvent(this.state.isChecked ? events.left : events.right, eventData);
      onClick(this.state.isChecked);
    });
  }

  render() {

    return (
      <StatelessSwitcher
        {...this.props}
        onClick={this.handleClick}
        isChecked={this.state.isChecked}
      />
    );
  }
};



// WEBPACK FOOTER //
// ./src/containers/Switcher/Switcher.js